import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '../helpers/analytics'

/**
 * Track page view on route change
 */
export const usePageTracking = () => {
  const location = useLocation()

  useEffect(() => {
    trackPageView(location.pathname)
  }, [location.pathname])
}
